/** SEC EDGAR filing index page on sec.gov (document list, not a raw file). */
export const buildSecFilingIndexPageUrl = (cik, accessionNumber) => {
  const digits = cik != null ? String(cik).replace(/\D/g, '') : '';
  const cikPath = digits ? String(parseInt(digits, 10)) : '';
  const accession = accessionNumber != null ? String(accessionNumber).trim() : '';
  if (!cikPath || !accession) return null;
  const folder = accession.replace(/-/g, '');
  return `https://www.sec.gov/Archives/edgar/data/${cikPath}/${folder}/${accession}-index.htm`;
};

export const resolveSecFilingPageUrl = (filing) => {
  if (!filing) return null;
  if (filing.edgarFilingPageUrl) return filing.edgarFilingPageUrl;
  const built = buildSecFilingIndexPageUrl(
    filing.cik || filing.displayCik,
    filing.accessionNumber || filing.id,
  );
  if (built) return built;
  if (filing.indexUrl && /-index\.htm/i.test(filing.indexUrl)) return filing.indexUrl;
  if (filing.documentUrl && /sec\.gov\/cgi-bin\/viewer/i.test(filing.documentUrl)) {
    return filing.documentUrl;
  }
  return null;
};
